import apiClient from "./ApiService";
import {  PATH_PROFESSIONS } from "../config/env";

export const getProfessions = async()=>{
    return await apiClient.get(PATH_PROFESSIONS);
}
export default getProfessions;